import { IMG_URL } from "api/client";

export const enText = (value) =>
  value && typeof value === "object" ? value.en || "" : value || "";

export const uniqueOptions = (items, slugKey, labelKey) => {
  const seen = new Set();
  return (items || []).reduce((list, item) => {
    const slug = item?.[slugKey];
    if (!slug || seen.has(slug)) return list;
    seen.add(slug);
    list.push({ slug, label: enText(item[labelKey]) || slug });
    return list;
  }, []);
};

export const getErrorMessage = (error) => {
  const message = error?.response?.data?.message;
  if (Array.isArray(message)) return message.filter(Boolean).join(", ");
  return message || error?.message || "Something went wrong";
};

export const imageUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${IMG_URL}/${String(path).replace(/^\//, "")}`;
};

export const isPreviewableImage = (path) =>
  /\.(jpg|jpeg|png|gif|webp)$/i.test(path || "");

export function getAtPath(obj, path) {
  if (!path) return obj;
  return path.split(".").reduce((acc, key) => {
    if (acc == null) return undefined;
    return acc[/^\d+$/.test(key) ? Number(key) : key];
  }, obj);
}

export function setAtPath(obj, path, value) {
  const keys = path.split(".");
  const clone = structuredClone(obj);
  let current = clone;
  for (let i = 0; i < keys.length - 1; i += 1) {
    const key = /^\d+$/.test(keys[i]) ? Number(keys[i]) : keys[i];
    const nextKey = keys[i + 1];
    if (current[key] == null) {
      current[key] = /^\d+$/.test(nextKey) ? [] : {};
    }
    current = current[key];
  }
  const last = keys[keys.length - 1];
  current[/^\d+$/.test(last) ? Number(last) : last] = value;
  return clone;
}

export function normalizeEn(value, path = "", frMap = {}) {
  if (value == null) return "";
  if (typeof value === "boolean" || typeof value === "number") return value;
  if (Array.isArray(value)) {
    return value.map((item, index) =>
      normalizeEn(item, path ? `${path}.${index}` : String(index), frMap)
    );
  }
  if (typeof value === "object") {
    if ("en" in value || "fr" in value) {
      if (value.fr) frMap[path] = value.fr;
      return value.en ?? "";
    }
    const out = {};
    Object.keys(value).forEach((key) => {
      if (["_id", "__v", "createdAt", "updatedAt"].includes(key)) return;
      out[key] = normalizeEn(
        value[key],
        path ? `${path}.${key}` : key,
        frMap
      );
    });
    return out;
  }
  return value;
}

export function deepMerge(base, incoming) {
  if (Array.isArray(incoming)) return incoming;
  if (
    incoming &&
    typeof incoming === "object" &&
    base &&
    typeof base === "object" &&
    !Array.isArray(base)
  ) {
    const out = { ...base };
    Object.keys(incoming).forEach((key) => {
      out[key] = deepMerge(base[key], incoming[key]);
    });
    return out;
  }
  return incoming === undefined ? base : incoming;
}
